import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { localStoreFN } from '../../store/localStorage';
import ObjGeneral from '../function/';
import Header from '../../components/allocator/header';
import MainTitle from '../../components/allocator/title';
import Button from '../../components/allocator/button';
import Table from '../../components/allocator/table';
import ModalDownload from '../../components/allocator/modalDownload';
import ModalUpdate from '../../components/allocator/modalUpdate';
import Message from '../../components/common/message';
import Loading from '../../components/common/loading';
import SweetAlert from 'react-bootstrap-sweetalert';
import uuidv1 from 'uuid/v1';

import constant from '../function/constants';

import toastr from 'toastr';

import { bindActionCreators } from 'redux';
import * as allocator from '../../actions/allocator';

class Asignador extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datos: [{ entityAlias: 'Jhon' }],
      datosAccount: [
        {
          id: 32,
          alias: 'JRGJ45',
          code: 'JRGJ45',
          state: true,
          hasHomologation: true,
          homologation: [],
          id: 32,
          state: true
        }
      ],
      dataRow: [],
      i: null,
      objectRow: {
        startDate: new Date(),
        endDate: null,
        timeStart: new Date(),
        timeEnd: null,
        person: undefined,
        equip: undefined,
        id: null
      },
      close: false, //close erorr pop up,
      modalDownload: false,
      modalUpdate: false,
      driverName: '',
      clear: false, // clear the first table row
      focus: true,
      showAlert: false,
      id: null,
      clearRow: false,
      defaultDate: null
    };
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('wizard');
    if (permit) {
    }

    await this.props.allocatorActions.fetchDriver();
    await this.props.allocatorActions.fetchEquip();
    await this.props.allocatorActions.fetchTest();
  }

  handleDriverName = (name, i) => {
    this.setState({ driverName: name, i: i });
  };

  defaultDate = defaultDate => {
    this.setState({ defaultDate: defaultDate });
  };

  //edited the table tableRow
  handleChangeSelectedName = (i, value) => {
    this.props.allocatorActions.changeName({ index: i, name: value });
  };

  // close pop up on click
  handleClose = e => {
    this.setState({ close: false });
  };

  handleModalDownload = async e => {
    e.preventDefault();
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalDownload ? false : true;
      this.setState({ modalDownload: reset });
    }
  };

  handleUpload = async e => {
    const btnUpload = document.getElementById('btn-upload');
    if (btnUpload.classList.contains('active')) {
      const fullPath = document.getElementById('file').files;
    }
  };

  handleUploadValue = async e => {
    const fullPath = document.getElementById('file').value;
    const btnUpload = document.getElementById('btn-upload');
    let extensionArr = fullPath.split('.');
    extensionArr = extensionArr[extensionArr.length - 1];
    if (
      (fullPath !== '' && extensionArr.toLowerCase() === 'xlsx') ||
      extensionArr.toLowerCase() === 'xls'
    ) {
      btnUpload.classList.add('active');
      document.getElementById('file-error').classList.add('none');
    } else {
      btnUpload.classList.remove('active');
      if (fullPath !== '') {
        document.getElementById('file-error').classList.remove('none');
      } else {
        document.getElementById('file-error').classList.add('none');
      }
    }
    document.getElementById('file-1').innerHTML = fullPath;
  };

  handleModalUpdate = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalUpdate ? false : true;
      this.setState({ modalUpdate: reset });
      // if (!reset) {
      //   if (this.props.statusFile == 200) {
      //     document.getElementById('search').value = '';
      //     this.setState({ pag: 1 });
      //     document.getElementById('search').value = '';
      //     this.setState({
      //       homologation: { a: true, b: false, c: false, d: false, e: false }
      //     });
      //     await this.props.actions.fetchAccountDriverApi({
      //       pag: 1,
      //       homologation: { a: true }
      //     });
      //     await this.props.actions.fetchAccountDriverCountApi({
      //       homologation: { a: true }
      //     });
      //   }
      //  this.props.actions.resetModalFileDriverAccount();
      // if (this.props.statusFile == null) {
      //   document.getElementById('file-error').classList.add('none');
      //   document.getElementById('file').value = '';
      //   document.getElementById('file-1').innerHTML = '';
      //   document.getElementById('btn-upload').classList.remove('active');
      // }
    }
  };

  handleDownload = async e => {
    this.setState({ modalDownload: false });
  };
  handleOpen = e => {
    this.setState({ close: true });
  };

  handleSearch = () => {};

  onSave = () => {
    this.setState({ dataRow: [] });
  };

  onCancel = () => {
    this.setState({ dataRow: [] });
  };

  handleSubmit = async obj => {
    /* GROUP */
    this.count = 0;
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate(obj, format);

    if (obj.id == 'date-start') {
      this.setState({ objectRow: { ...this.state.objectRow, startDate: date } });
    } else if (obj.id === 'date-end') {
      this.setState({ objectRow: { ...this.state.objectRow, endDate: date } });
    }
  };

  handleSubmitAutoComplete = obj => {
    let uuid = uuidv1();
    if ((obj.id === 'au-1') | obj.value) {
      this.setState({
        objectRow: { ...this.state.objectRow, person: obj.value, id: uuid },
        clearRow: false,
        clear: false
      });
    } else if (obj.id === 'au-2') {
      this.setState({ objectRow: { ...this.state.objectRow, equip: obj.value } });
    }
  };

  handleSubmitTime = obj => {
    if (obj.id === 'init') {
      this.setState({ objectRow: { ...this.state.objectRow, timeStart: obj.value } });
    } else if (obj.id === 'end') {
      if (!this.state.objectRow.person) {
        let person = 'Porfavor selecione un conductor';
        this.setState({
          objectRow: {
            ...this.state.objectRow,
            person
          }
        });
      }

      if (!this.state.objectRow.equip) {
        let equip = 'Porfavor selecione un equipo';
        this.setState({
          objectRow: {
            ...this.state.objectRow,
            equip
          }
        });
      }

      this.setState({
        objectRow: { ...this.state.objectRow, timeEnd: obj.value }
      });
    }
  };

  // Add asignation to memory
  handleAsignation = event => {
    toastr.options = constant.tostrOptions;
    if (this.state.objectRow['person'] != undefined && this.state.objectRow['equip'] != undefined) {
      if (
        this.state.objectRow['person'].startsWith('Porfavor') ||
        this.state.objectRow['equip'].startsWith('Porfavor')
      ) {
        return toastr.error('La fecha inocio debe ser inferior a la fecha final', 'erorr');
      }
      if (this.state.objectRow.startDate && this.state.objectRow.endDate) {
        if (
          this.state.objectRow.startDate.fechaStartFinal >
          this.state.objectRow.endDate.fechaEndFinal
        ) {
          toastr.error('La fecha inocio debe ser inferior a la fecha final', 'erorr');
          return;
        }
      }

      if (this.props.isDuplicate) {
        return toastr.error('asignación duplicado!', 'erorr');
      }

      this.props.allocatorActions.addAsignation(this.state.objectRow);

      this.setState({
        objectRow: {
          ...this.state.objectRow,
          endDate: null,
          timeEnd: null,
          person: undefined,
          equip: undefined
        },
        clear: false,
        clearRow: true
      });
    } else {
      return toastr.error('Debes llenar los campos : Persona, Equipo y fecha inocio', 'erorr');
    }

    const autoComplete = document.getElementById('au-1').focus();
  };

  deleteAsignation = event => {
    let id = event.target.dataset.index;
    this.props.allocatorActions.deleteAsignation(id);
  };

  unClear = () => {
    this.setState({ clear: false });
  };

  clearAsignation = event => {
    this.setState({ clearRow: true, objectRow: {} });
  };

  resetClear = event => {
    this.setState(prevstate => {
      return { clearRow: !prevstate.clearRow };
    });
  };

  handleFocus = () => {
    this.setState({ focus: true });
  };

  handleShowAlert = () => {
    this.setState({ showAlert: true });
  };

  handleHideAlert = () => {
    this.setState({ showAlert: false });
  };

  render() {
    let aliasArr = this.props.test.datos ? this.props.test.datos.data : [];
    // the setting object is obtained which we use for the configuration
    const obj = JSON.parse(this.props.setting.value);
    let status = this.props.allocator ? this.props.allocator.status : null;
    // function that configures the settings according to those defined in the view
    const setting = ObjGeneral.getSetting({
      setting: obj.summaryTruck,
      filter: this.props.filter,
      general: obj.generalSetting
    });

    // condition done to see if the setting was done
    if (this.props.setting) {
      const header = (
        <Header handleSearch={this.handleSearch} language={this.props.language.filter} />
      );
      let container = '';
      // condition performed for loading state of the view
      if (!status) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (status === 401) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (status === 200) {
        container = (
          <div className="main-container scroll">
            <MainTitle />
            <Button
              language={this.props.language}
              handleCancel={this.onCancel}
              handleSave={this.onSave}
              handleModalDownload={this.handleModalDownload}
              handleModalUpdate={this.handleModalUpdate}
              arrLength={this.state.dataRow.length}
              handleShowAlert={this.handleShowAlert}
            />
            <Table
              datos={this.state.datos}
              datosAccount={this.props.allocator ? this.props.allocator.data : []}
              equip={this.props.equip ? this.props.equip.data : []}
              //  handleSubmit={this.handleSubmit}
              date={this.props.dateMax[3]}
              filters={this.props.filters}
              handleSubmit={this.handleSubmit}
              handleSubmitAutoComplete={this.handleSubmitAutoComplete}
              handleSubmitTime={this.handleSubmitTime}
              dataRow={this.props.asignation}
              close={this.state.close}
              handleClose={this.handleClose}
              handleOpen={this.handleOpen}
              checkIfExist={this.props.allocatorActions}
              isDriver={this.props.isDriver}
              test={this.props.test.datos ? this.props.test.datos : []}
              handleDriverName={this.handleDriverName}
              driverName={this.state.driverName}
              handleChangeSelectedName={this.handleChangeSelectedName}
              clear={this.state.clear}
              unClear={this.unClear}
              focus={this.state.focus}
              handleFocus={this.handleFocus}
              handleAsignation={this.handleAsignation}
              deleteAsignation={this.deleteAsignation}
              clearRow={this.state.clearRow}
              clearAsignation={this.clearAsignation}
              resetClear={this.resetClear}
              handleSelect={this.handleSelect}
              value={this.state.value}
              memory={this.state.memory}
              defaultDate={this.defaultDate}
              allocatorActions={this.props.allocatorActions}
            />
            <ModalDownload
              handleModal={this.handleModalDownload}
              modal={this.state.modalDownload}
              handleDownload={this.handleDownload}
              language={this.props.language ? this.props.language : ''}
            />

            <ModalUpdate
              handleDownload={this.handleDownload}
              handleUpload={this.handleUpload}
              handleUploadValue={this.handleUploadValue}
              handleModal={this.handleModalUpdate}
              modal={this.state.modalUpdate}
              //  datos={this.props.datosFile}
              //  loading={this.props.loadingFile}
              status={null}
              language={this.props.language ? this.props.language : ''}
            />
            {this.state.showAlert && (
              <SweetAlert
                danger
                showCancel
                confirmBtnText={'Guardar'}
                title={
                  <div>
                    <span className="modal-title">Asignar personas</span>
                  </div>
                }
                closeOnClickOutside={true}
                cancelBtnText={'Cancelar'}
                cancelBtnCssClass="cancel-buton-test"
                confirmBtnCssClass="confirm-button"
                onConfirm={this.handleHideAlert}
                onCancel={this.handleHideAlert}
              >
                <div className="tilte-modal-box justify-text">
                  <h5>
                    Existen errores en algunas filas. ¿Desea guardar las asignaciones sin errores de
                    todas formas?{' '}
                  </h5>
                  <h5>
                    * Esta acción hara que todas las acciones con errores queden pendientes de
                    asignación
                  </h5>
                </div>
              </SweetAlert>
            )}
          </div>
        );
        // the 500 status of the application
      } else if (status === 500) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main" onScroll={this.handleScroll}>
          {header}
          {container}
        </section>
      );
    }
    // in case the setting is not loaded
    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}
const mapStateToProps = state => ({
  setting: state.reducer.dashboard.setting,
  language: state.reducer.dashboard.language,
  filters: state.reducer.summaryTruck.filters,
  dateMax: state.reducer.dashboard.dateMax,
  allocator: state.reducer.allocator.datos,
  equip: state.reducer.allocator.equip.datos,
  test: state.reducer.allocator.test,
  isDriver: state.reducer.allocator.exist,
  asignation: state.reducer.allocator.asignation,
  isDuplicate: state.reducer.allocator.isDuplicate
});
const mapDispatchToProps = dispatch => ({
  allocatorActions: bindActionCreators(allocator, dispatch)
});
Asignador.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Asignador);



// WEBPACK FOOTER //
// ./source/client/containers/allocator/index.jsx